"use client";
import { ProductSortOrder } from "@/lib/products";
import * as React from "react";
import {useAppSelector} from "@/redux/hooks";
import { RootState } from "@/redux/store";
import {Box, useTheme, Typography, SxProps} from "@mui/material";
import FaIcon from "@/components/utilities/fa-icon";
import {Theme} from "@mui/material/styles";
import {useProductsFilters} from "@/hooks/useProductsFilters";

export default function ProductsSortSelect() {
    const theme = useTheme();

    const sortOrder = Number(
        useAppSelector((state: RootState) => state.products.SortOrder)
    );
    const {updateFilters} = useProductsFilters();
    const isAdmin = useAppSelector((state: RootState) =>
        state.user.currentUser?.roles.includes("Admin")
    );

    const getStyle = (order: ProductSortOrder): SxProps<Theme> => ({
        cursor: "pointer",
        fontWeight: sortOrder === order ? 350 : 300,
        color: sortOrder === order
            ? theme.palette.primary.button
            : theme.palette.primary.main,
        position: "relative",
        transition: "all 0.3s ease",
        "&:hover": {
            color: theme.palette.primary.button,
            transform: "translateY(-1px)",
        },
        "&::after": {
            content: '""' as const,
            position: "absolute",
            left: 0,
            bottom: -4,
            height: "1px",
            width: sortOrder === order ? "100%" : "0%",
            backgroundColor: theme.palette.primary.button,
            transition: "width 0.3s ease",
        },
        "&:hover::after": {
            width: "100%",
        },
    });


    return (
        <Box
            fontSize={14}
            color={theme.palette.grey[600]}
            display='flex'
            alignItems='center'
            gap={1}
        >

            <FaIcon
                fontSize={20}
                color={theme.palette.primary.main}
                sx={{ transform: "scaleX(-1)" }}
                faIcon="fa-arrow-down-wide-short"
            />

            <Typography fontWeight={400} color={theme.palette.primary.main}>
                مرتب سازی:
            </Typography>

            <Box display="flex" gap={2} flexWrap="wrap" >
                <Box
                    component="span"
                    sx={getStyle(ProductSortOrder.Newest)}
                    onClick={() => updateFilters({SortOrder: ProductSortOrder.Newest})}
                >
                    جدیدترین
                </Box>
                <Box
                    component="span"
                    sx={getStyle(ProductSortOrder.Alphabet)}
                    onClick={() => updateFilters({SortOrder: ProductSortOrder.Alphabet})}
                >
                    حروف الفبا
                </Box>
                <Box
                    component="span"
                    sx={getStyle(ProductSortOrder.Cheapest)}
                    onClick={() => updateFilters({SortOrder: ProductSortOrder.Cheapest})}
                >
                    کمترین قیمت
                </Box>
                <Box
                    component="span"
                    sx={getStyle(ProductSortOrder.MostExpensive)}
                    onClick={() => updateFilters({SortOrder: ProductSortOrder.MostExpensive})}
                >
                    بیشترین قیمت
                </Box>

                {isAdmin && (
                    <Box
                        component="span"
                        sx={getStyle(ProductSortOrder.MostRecentPictureAdded)}
                        onClick={() =>
                            updateFilters({SortOrder: ProductSortOrder.MostRecentPictureAdded})
                        }
                    >
                        تاریخ اضافه‌شدن عکس
                    </Box>
                )}
            </Box>
        </Box>
    );
}
